var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1C36.7025 1 47 11.2975 47 24C47 36.7025 36.7025 47 24 47C11.2975 47 1 36.7025 1 24C1 11.2975 11.2975 1 24 1Z",
    stroke: "#D03B20",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7609 19.1998C35.7609 19.1998 35.5266 17.5451 34.8047 16.8186C33.8906 15.8623 32.8688 15.8576 32.4 15.8014C29.0438 15.5576 24.0047 15.5576 24.0047 15.5576H23.9953C23.9953 15.5576 18.9563 15.5576 15.6 15.8014C15.1313 15.8576 14.1094 15.8623 13.1953 16.8186C12.4734 17.5451 12.2437 19.1998 12.2437 19.1998C12.2437 19.1998 12 21.1451 12 23.0857V24.9045C12 26.8451 12.2391 28.7904 12.2391 28.7904C12.2391 28.7904 12.4734 30.4451 13.1906 31.1717C14.1047 32.1279 15.3047 32.0951 15.8391 32.1982C17.7609 32.3811 24 32.4373 24 32.4373C24 32.4373 29.0438 32.4279 32.4 32.1889C32.8688 32.1326 33.8906 32.1279 34.8047 31.1717C35.5266 30.4451 35.7609 28.7904 35.7609 28.7904C35.7609 28.7904 36 26.8498 36 24.9045V23.0857C36 21.1451 35.7609 19.1998 35.7609 19.1998ZM21.5203 27.1123V20.367L28.0031 23.7514L21.5203 27.1123Z",
    fill: "#D03B20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fb3ed27ba279a1ca53eb9324bc828226.svg";
export { ForwardRef as ReactComponent };